import React from "react";
import ItemQuantity from "./ItemQuantity";

export default class CartItem extends React.Component {
    render() {
        return <div className="cart-item">
            <img className="image" src={this.props.imageSrc} />

            <div className="details">
                <span className="name">{this.props.name}</span>
                <span className="price" dangerouslySetInnerHTML={{__html: this.props.price}}></span>
                <span className="size-label">Size: <span className="size">{this.props.size}</span></span>
                <div className="quantity">
                    <span className="qty-label">Quantity:</span>
                    <ItemQuantity id={this.props.id} cartKey={this.props.cartKey} quantity={this.props.quantity} />
                </div>
            </div>
        </div>;
    }
}